import React, { useEffect, useState } from 'react';
import { Horse, useHorse } from '../../contexts/HorseContext';
import { HorseDetails } from './HorseDetails';
import { HorseImage } from './HorseImage';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Impressum } from '../Legal/Impressum';
export const WeighingPage: React.FC = () => {
  const {
    horses
  } = useHorse();
  const [selectedHorse, setSelectedHorse] = useState<Horse | null>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showImpressum, setShowImpressum] = useState(false);
  const navigate = useNavigate();
  // Get the selected horse ID from session storage
  useEffect(() => {
    const selectedHorseId = sessionStorage.getItem('selectedHorseId');
    if (selectedHorseId) {
      const horse = horses.find(h => h.id === selectedHorseId);
      if (horse) {
        setSelectedHorse(horse);
        return;
      }
    }
    // If no horse is selected or the selected horse doesn't exist,
    // redirect to the horse selection page
    if (horses.length > 0) {
      navigate('/select-horse');
    }
  }, [horses, navigate]);
  const handleHorseChange = (horse: Horse) => {
    setSelectedHorse(horse);
    sessionStorage.setItem('selectedHorseId', horse.id);
    setIsDropdownOpen(false);
  };
  const toggleImpressum = () => {
    setShowImpressum(!showImpressum);
  };
  if (!selectedHorse) {
    return <div className="flex items-center justify-center h-full" data-id="element-369">
        <p className="text-gray-500" data-id="element-370">Lade...</p>
      </div>;
  }
  if (showImpressum) {
    return <Impressum onBack={toggleImpressum} data-id="element-371" />;
  }
  return <div className="w-full max-w-full" data-id="element-372">
      <div className="flex justify-between items-center mb-4" data-id="element-373">
        <div className="flex items-center" data-id="element-374">
          <h1 className="text-2xl font-bold" data-id="element-375">Pferd verwiegen</h1>
          <button onClick={toggleImpressum} className="ml-4 text-xs text-gray-600 hover:text-gray-900 hover:underline" data-id="element-376">
            Impressum
          </button>
        </div>
        <div className="relative" data-id="element-377">
          {isDropdownOpen && <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10" data-id="element-378">
              {horses.map(horse => <button key={horse.id} onClick={() => handleHorseChange(horse)} className="block w-full text-left px-4 py-2 hover:bg-gray-100" data-id="element-379">
                  {horse.name}
                </button>)}
            </div>}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-380">
        <HorseDetails horse={selectedHorse} data-id="element-381" />
        <HorseImage horse={selectedHorse} data-id="element-382" />
      </div>
    </div>;
};